var render, staticRenderFns
import script from "./BuyNowConfirmation.vue?vue&type=script&lang=js&"
export * from "./BuyNowConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./BuyNowConfirmation.vue?vue&type=style&index=0&id=3fdbd256&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdbd256",
  null
  
)

export default component.exports